module.exports = __webpack_public_path__ + "img/goal-08.ee4e5156.png";